import { useSelector } from 'react-redux';
import { useAction, useProgressFailed, useProgressSuccess } from 'hooks';
import App from 'modules/App';
import * as selectors from '../../../selectors';
import { GUARDIAN_CONFIRMATION_STATUS_MODAL } from '../../../constants';
const useConfirmationStatus = (onConfirmationCompleted)=>{
    const isInProgress = useSelector(selectors.isCheckConfirmTermsOfServicesByGuardianProgress);
    const hasError = useSelector(selectors.hasCheckConfirmTermsOfServicesByGuardianErrors);
    const openModal = useAction(App.actions.openModal, GUARDIAN_CONFIRMATION_STATUS_MODAL);
    const onSuccess = ()=>{
        onConfirmationCompleted();
    };
    useProgressSuccess(isInProgress, hasError, onSuccess);
    useProgressFailed(isInProgress, hasError, openModal);
};
export default useConfirmationStatus;
